module.exports = __webpack_public_path__ + "static/media/backendless-auth-logo.2a4044d5.png";